import modal from './modal';
import util from './util';
var customerData={
	               firstName : window.User.firstName,
				   lastName : window.User.lastName,
				   email : window.User.email,
				   phone : window.User.phone
};

function initializeEvents() {
    window.addEventListener('message', function(e) {
        if (e.data.indexOf('iFrameSizer') >= 0) {return false;}
        //console.log(e);
		
        var originalEvent = e.origin ? e : e.originalEvent;
		
        var allowedOrigins = [
            'https://qa-nars.skedge.me',
            'https://nars.skedge.me'
        ];

        if(allowedOrigins.indexOf(originalEvent.origin) >= 0) {
            var data = JSON.parse(originalEvent.data);

            window.dataLayer.push(data);
			
            if(data.type == 'request' && data.resource == 'user') {
                if(window.User.isCustomerAuthenticated != false) {
                    sendCustomerData(customerData.firstName, customerData.lastName, customerData.email, customerData.phone);
                } else {
                    openLoginModal();
                }
            } else if (data.type == 'push' && data.resource == 'page-transition'){
                $('html, body').animate({scrollTop: 0}, 'slow');
            } else if (data.type == 'push' && data.resource == 'no-appointments'){
                $('.skedge').addClass('no-appointments');
            }
        }
    }, false);
}

function openLoginModal() {
    modal.restoreDefaultClass();
    modal.addCustomClass('login-modal login-modal-skedge noGuest');
    modal.renderByUrl(Urls.SkedgeLogin);
}

function initLoginFormSubmit() {
    $(document).on('submit', '.login-modal-skedge form[id$=_login]', function(e) {
        e.preventDefault(e);
        var form = $(this);
        if(!form.valid())	{return;}

        var url = util.appendParamToURL(form.attr('action'), 'format', 'ajax');
        var data = form.serialize() + '&' + $('[name$=_login_login]').attr('name') + '=login';
        $.ajax({
            url : url,
            data: data,
            type: 'POST'
        }).done(function(data) {
            if(!data) {return;}

            if (!data.loginSuccess) {
                $('.error-form').remove();
                form.prepend('<div class=\'error-form\'>' + data.errorMessage + '<br></div>');
                return;
            }
            sendCustomerData(data.firstName, data.lastName, data.email, data.phone);
            customerData.firstName = data.firstName;
            customerData.lastName = data.lastName;
            customerData.email =  data.email;
            customerData.phone = data.phone;
			 url = '';
			 url= util.appendParamToURL(Urls.includeGreeting, 'format', 'ajax');
			 
			 $.ajax({
 			  	url: url,
  			  	type:'GET',
   			  	success: function(response){		  	 			  	
       				$('.menu-utility-user .sign-in-wrapper').html(response).foundation();
       		  	}
  			  
            });		
			
            modal.close();
        });
	
    });
}


//function to send data to skedge iframe
function sendCustomerData(firstName, lastName, email, phone){
    var customerData = JSON.stringify({
        'type': 'response',
        'resource': 'user',
        'data': {
            'email': email,
            'firstName': firstName,
            'lastName': lastName,
            'phone': phone
        }
    });
    //if (!browserWidthIsDesktop() || $('.skedge').length == 1) {
    if ((window.innerWidth < 1195) || $('.skedge').length == 1) {
        $('.skedge')[0].contentWindow.postMessage(customerData, '*');
    } else {
        $('.skedge')[1].contentWindow.postMessage(customerData, '*');
    }
}

var skedge = {
    init: function() {
		
        if($('.skedge').length == 0) {return false;}
		
        if (window.innerWidth < 1195) {
            if ($('#main').find('.skedge').length)    { $('#main').css({'margin': 0}); }
            if ($('#wrapper').find('.skedge').length) { $('#wrapper').css({'margin': 0}); }
        }
		
        initializeEvents();
        initLoginFormSubmit();
    }
}

export default skedge;
